import React from "react";

const DetailedImageBar = ({ description, images, onImageClicked }) => {
  return (
    <div className="divColumn" style={{ width: "80%" }}>
      <div
        className="divRow"
        style={{
          position: "relative",
          width: "100%",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            backgroundColor: "#2f2f2f",
            borderRadius: ".5rem.5rem 0 0",
            opacity: 0.8,
          }}
        />
        <div className="textBoldWhite" style={{ zIndex: 1 }}>
          {description}
        </div>
      </div>
      {
        <div
          className="divRow"
          style={{
            width: "100%",
            overflow: "auto",
            justifyContent: "space-around",
            minHeight: "60px",
            alignContent: "center",
            position: "relative",
            borderBottomRightRadius: ".5rem",
            borderBottomLeftRadius: ".5rem",
          }}
        >
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              backgroundColor: "#7f7f7f",
              opacity: 0.5,
            }}
          />
          {images.length > 0 &&
            images.map((image) => (
              <img
                src={image}
                style={{ objectFit: "contain", zIndex: 1, height: "60px" }}
                key={image}
                onClick={() => onImageClicked(image)}
              />
            ))}
          {images.length == 0 && (
            <div className="textBold">No Images uploaded</div>
          )}
        </div>
      }
    </div>
  );
};

export default DetailedImageBar;
